import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { contactInfo } from '../data/businessData';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Get In Touch</h2>
          <p className="lead text-muted">
            Ready to service your vehicle? Contact us today for expert automobile care
          </p>
        </div>

        <Row>
          <Col lg={6} className="mb-4">
            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-primary text-white rounded-circle p-3 me-3">
                    📞
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Phone Number</h6>
                    <p className="text-muted mb-0">{contactInfo.phone}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-success text-white rounded-circle p-3 me-3">
                    ✉️
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Email Address</h6>
                    <p className="text-muted mb-0">{contactInfo.email}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-warning text-white rounded-circle p-3 me-3">
                    📍
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Our Location</h6>
                    <p className="text-muted mb-0">{contactInfo.address}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-info text-white rounded-circle p-3 me-3">
                    🕒
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Working Hours</h6>
                    <p className="text-muted mb-0">{contactInfo.hours}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className="bg-dark text-white border-0 text-center">
              <Card.Body className="py-5">
                <h3 className="fw-bold mb-3">Ready to Book Your Service?</h3>
                <p className="lead mb-4">
                  Get your car serviced by experts. Call us now or visit our workshop.
                </p>
                <div className="d-flex justify-content-center gap-3">
                  <Button 
                    variant="warning" 
                    size="lg" 
                    className="fw-bold"
                    href={`tel:${contactInfo.phone}`}
                    as="a"
                  >
                    📞 Call Now
                  </Button>
                  <Button 
                    variant="outline-light" 
                    size="lg" 
                    className="fw-bold"
                    href={`mailto:${contactInfo.email}`}
                    as="a"
                  >
                    ✉️ Email Us
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;